import React from "react";

export default () => (
    <span className="hyphen"> - </span>
)
